/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { shape, string, object, bool, array, func } from 'prop-types';
import { connect } from 'react-redux';

import p from 'polyglot/polyglot';

import { createUrl } from 'utils/urlHelper';

import { updateCompany as updateCompanyAction } from 'actions/company';

import { makeUpdateCompanyForm } from 'selectors/updateCompanyForm';

import Form from 'components/Form/Form';
import StaffList from 'components/StaffList/StaffList';
import Button from 'components/Button/Button';

import styles from './edit.scss';

/**
 * This is the Edit component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class Edit extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    auth: shape({
      token: string.isRequired,
    }).isRequired,
    user: shape({
      type: string.isRequired,
      company: shape({
        name: string.isRequired,
        vat: string.isRequired,
      }).isRequired,
    }).isRequired,
    companyForm: shape({
      fieldsets: array.isRequired,
      validationMessages: object.isRequired,
      submitText: string.isRequired,
      sending: bool.isRequired,
      errors: object.isRequired,
    }).isRequired,
    updateCompany: func.isRequired,
  };

  updateCompany = data => {
    const {
      auth: { token },
      user: { type },
      updateCompany,
    } = this.props;

    updateCompany(token, { ...data, role_type: type });
  };

  /**
   * Render Edit.
   *
   * @return {Object}
   */
  render() {
    const {
      user: { company },
      companyForm,
    } = this.props;

    return (
      <section className={styles.row}>
        <div className={styles.content}>
          <header className={styles.header}>
            <h1>{company.name}</h1>
            <h2>{company.vat}</h2>
          </header>

          <div className={styles.staff}>
            <header className={styles.staffHeader}>
              <h2>{p.t('company.staff.title')}</h2>
              <p>
                {p.t('company.staff.remove_colleague')}{' '}
                <a
                  href={`mailto:${p.t('company.staff.remove_colleague_email')}`}
                >
                  {p.t('company.staff.remove_colleague_email')}
                </a>
              </p>
            </header>

            <StaffList companyId={company.company_id} wide />

            <footer className={styles.staffFooter}>
              <Button path={createUrl('inviteColleague')}>
                {p.t('company.staff.invite')}
              </Button>
            </footer>
          </div>

          <div className={styles.form}>
            <Form {...companyForm} onSubmit={this.updateCompany} />
          </div>
        </div>
      </section>
    );
  }
}

/**
 * Map state from redux store to props.
 */
const makeMapStateToProps = () => {
  const updateCompanyForm = makeUpdateCompanyForm();
  const mapStateToProps = (state, props) => {
    return {
      auth: state.auth,
      user: state.user,
      companyForm: updateCompanyForm(state, props),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps, {
  updateCompany: updateCompanyAction,
})(Edit);
